import FullWidthTextSection from "./FullWidthTextSection";

const FullWidthTextSectionWithProps = ({ blok }) => {
  return <FullWidthTextSection text={blok.text} title={blok.title} />;
};

export default FullWidthTextSectionWithProps;
